import React, { Component } from 'react';
import classNames           from 'classnames'
import styles               from './index.css';
import ArrowLeft            from '@material-ui/icons/KeyboardArrowLeft';
import ArrowRight           from '@material-ui/icons/KeyboardArrowRight';
import Close                from '@material-ui/icons/Close';

var initialPoint;
var finalPoint;

export default class Gallery extends Component {  
  componentDidMount(){
    let wr = document.querySelector('.'+styles['modalImgWrapper']);
    wr.addEventListener('touchstart', this.startSwipe );
    wr.addEventListener('touchend', this.endSwipe );
  }
  componentWillUnmount(){
    let wr = document.querySelector('.'+styles['modalImgWrapper']);
    wr.removeEventListener('touchstart', this.startSwipe );
    wr.removeEventListener('touchend', this.endSwipe );
  }
  startSwipe = event => {
    event.preventDefault();
    event.stopPropagation();
    initialPoint=event.changedTouches[0];
  }
  endSwipe = event =>{
    event.preventDefault();
    event.stopPropagation();
    finalPoint=event.changedTouches[0];
    var xAbs = Math.abs(initialPoint.pageX - finalPoint.pageX);
    var yAbs = Math.abs(initialPoint.pageY - finalPoint.pageY);
    if (xAbs > 20 || yAbs > 20) {
      if (xAbs > yAbs) {
        if (finalPoint.pageX < initialPoint.pageX){
          this.prevImg();
        }else{
          this.nextImg();
        }
      }
    }else{
      if(event.target.closest('.'+styles['arrowLeft'])){
        this.prevImg();
      }else{
        if(event.target.closest('.'+styles['arrowRight'])){
          this.nextImg();
        }
      }
    }
  }
  mobile(){
    if(document.documentElement.clientWidth < 24) return true;
    return false;
  }
  closeModal = () => {
    this.props.isClose();
  }
  prevImg = () => {
    if(this.props.isActive === 0){
      this.props.nextActive(this.props.images.length - 1);
    }else{
      this.props.nextActive(this.props.isActive - 1);
    }
  }
  nextImg = () => {
    if( this.props.isActive === (this.props.images.length - 1) ){
      this.props.nextActive(0);
    }else{
      this.props.nextActive(this.props.isActive + 1);
    }
  }
  render() {
    return (
      <div className={classNames(styles['modalWrapper'], this.props.isOpen && styles['is-open'])}>

        <div className={classNames(styles['closeWrapper'])} onClick={this.closeModal}>
          <Close className={styles.closeIcon}/>
        </div>

        <div className={classNames(styles['modalImgWrapper'])}>

          {this.props.images.map( (img,i) => {
            return(
              <div className={classNames(styles['modalImgWr'], this.props.isActive === i? styles['is-active']:'')} key={i}>
                <img alt="" src={this.props.ADMIN_URL+img} className={classNames(styles['modalImg'])} />
              </div>
            )
          })}

          {!this.mobile()&&<div className={classNames(styles['arrowLeft'])}  onClick={this.prevImg}> <ArrowLeft className={styles.arrowLeftIcon}/>   </div>}
          {!this.mobile()&&<div className={classNames(styles['arrowRight'])} onClick={this.nextImg}> <ArrowRight className={styles.arrowRightIcon}/> </div>}

        </div>

        <div className={classNames(styles['modalBG'])} onClick={this.closeModal}></div>

      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/blocks/MyGallery/index.js